var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapeauengFichier14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.53 68.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#2e4593;}.cls-3{fill:#d63932;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.06,18.08c-1.32,2.45-2.34,5.09-3.04,7.86H14.65l-10.59-7.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.94,1.02c-6.13,1.53-11.6,4.7-15.92,9.03l15.92,11.81V1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.59,67.5c6.13-1.53,11.6-4.7,15.92-9.03l-15.92-11.81v20.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.47,50.45c1.32-2.46,2.34-5.09,3.04-7.86h-13.63l10.59,7.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.5,25.94c-.69-2.77-1.72-5.4-3.04-7.86l-10.59,7.86h13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.65,42.59H1.02c.69,2.77,1.72,5.4,3.04,7.86l10.59-7.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.01,58.47c4.32,4.33,9.8,7.5,15.92,9.03v-20.84l-15.92,11.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.51,10.06c-4.32-4.33-9.8-7.5-15.92-9.03V21.87l15.92-11.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.04,25.94L6.74,13.85c-.66,.89-1.28,1.82-1.86,2.77l12.56,9.32h5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.49,42.59l16.29,12.09c.66-.89,1.28-1.82,1.86-2.77l-12.56-9.32h-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.94,42.59h-2.9L6.74,54.67c.66,.89,1.37,1.75,2.11,2.58l17.08-12.67v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.59,25.94h2.9l16.29-12.09c-.66-.89-1.37-1.75-2.12-2.58l-17.08,12.67v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.16,39.26h-28.9v28.9c1.13-.17,2.24-.39,3.33-.66v-20.84l15.92,11.81c1.18-1.18,2.27-2.45,3.27-3.79l-16.29-12.09h5.59l12.56,9.32c.29-.48,.56-.96,.83-1.46l-10.59-7.86h13.63c.27-1.09,.49-2.2,.66-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.5,25.94h-13.63l10.59-7.86c-.79-1.48-1.69-2.89-2.68-4.23l-16.29,12.09h-2.9v-2l17.08-12.67c-.38-.41-.76-.82-1.16-1.22l-15.92,11.81V1.02c-1.09-.27-2.2-.49-3.33-.66V29.27h28.9c-.16-1.13-.38-2.24-.66-3.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.37,39.26c.16,1.13,.38,2.24,.66,3.33H14.65l-10.59,7.86c.79,1.48,1.69,2.89,2.68,4.23l16.29-12.09h2.9v2l-17.08,12.67c.38,.41,.76,.82,1.16,1.22l15.92-11.81v20.84c1.09,.27,2.2,.49,3.33,.66v-28.9H.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.94,1.02V21.87L10.01,10.06c-1.18,1.18-2.27,2.45-3.27,3.79l16.29,12.09h-5.59L4.89,16.62c-.29,.48-.56,.97-.83,1.46l10.59,7.86H1.02c-.27,1.09-.49,2.2-.66,3.33H29.27V.37c-1.13,.17-2.24,.39-3.33,.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.16,29.27h-28.9V.37c-1.63-.24-3.3-.37-5-.37s-3.36,.13-4.99,.37V29.27H.37c-.24,1.63-.37,3.3-.37,5s.13,3.36,.37,5H29.27v28.9c1.63,.24,3.3,.37,4.99,.37s3.37-.13,5-.37v-28.9h28.9c.24-1.63,.37-3.3,.37-5s-.13-3.36-.37-5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeauengFichier14);
export default __webpack_public_path__ + "static/media/DRAPEAU ENGFichier 14.21e00ce62f772c672c087777fed160a0.svg";
export { ForwardRef as ReactComponent };